var map = {
	"./0.png": "750b",
	"./1.png": "58cb",
	"./2.png": "e493",
	"./3.png": "15d2",
	"./4.png": "bbd9",
	"./5.png": "a789",
	"./6.png": "ace6",
	"./7.png": "d1e6",
	"./8.png": "dc93"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "61b0";